<div class="login-body">
    <div class="login-panel p-fluid">
        <p-messages [(value)]="errorMessages" [closable]="false"></p-messages>
        <div class="p-grid login-container" style="padding-bottom: 20px;">
            <div class="p-col-12 logo-container">
                <img src="assets/title_logo.png" class="morpheus-logo" />
            </div>
            <div class="p-col-12">
                <input type="verificationCode" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="verificationCode"
                    placeholder="Verification Code">
            </div>
            <div class="p-col-12">
                <input type="password" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="password"
                    placeholder="Password">
            </div>
            <div class="p-col-12 button-container">
                <button type="button" (click)="onNext()" class="p-button blue-btn raised-btn p-widget p-state-default p-corner-all p-button-text-icon-left">
                        <span class="p-button-text p-c">Reset Password</span>
                    </button>
            </div>
        </div>

        <div class="stripe"></div>
        <p style="margin-left: -17px;"><a [routerLink]="['/resendCode']">Resend Code</a></p>
        <div class="stripe"></div>
    </div>
</div>

